
import React, { Fragment as F,
  createContext,
  useContext, useEffect, useState,
} from 'react'

import {
  C,
  defaultBanksQueryTmpl,
} from '$shared'

import {
  SchedulesCtx,
} from '$src/components/schedules'


import BankTabs from './BankTabs'
import ContactsList from './ContactsList'
import Criterion, {
  // Criteria,
  operator,
} from './Criterion'
import CriterionModal from './CriterionModal'

import BankSchedules from './BankSchedules'
// import BankShow from './BankShow'

import BanksIndexTable from './BanksIndexTable'
import BanksSearchModal, { Tab, TabList, TabPanel } from './BanksSearchModal'

import ResultsTable from './ResultsTable'

const BanksCtx = createContext({
  sortedResults: [],
})



/**
 * BanksProvider
**/
const BanksProvider = ({ children, ...props }) => {

  const [ activeBankTab, setActiveBankTab ] = useState(false)
  const [ banksSearchModalOpen, setBanksSearchModalOpen ] = useState(false)
  const [ criterionModalOpen, setCriterionModalOpen ] = useState(false)
  const [ results, setResults ] = useState([])
  const [ resultsTitle, setResultsTitle ] = useState(null)

  const [ rssd, setRssd ] = useState(null)
  const [ bank, setBank ] = useState({})
  const [ selectedBanks, setSelectedBanks ] = useState({})
  const [ sortedResults, setSortedResults ] = useState([])
  const [ query, setQuery ] = useState(JSON.parse(JSON.stringify(defaultBanksQueryTmpl))) // actually clauses

  const {
    setOneResultTitle, defaultOneResultTitle,
  } = useContext(SchedulesCtx)

  const clearResults = () => {
    setOneResultTitle(defaultOneResultTitle)
    setResults([])
    setResultsTitle(null)
    setSelectedBanks({})
  }

  return <BanksCtx.Provider value={{
    activeBankTab, setActiveBankTab,
    bank, setBank,
    banksSearchModalOpen, setBanksSearchModalOpen,
    criterionModalOpen, setCriterionModalOpen,
    query, setQuery,
    results, setResults, clearResults,
    resultsTitle, setResultsTitle,
    rssd, setRssd,
    selectedBanks, setSelectedBanks,
    sortedResults, setSortedResults,
  }}>{ children }</BanksCtx.Provider>
}

export {
  /* sg */
  BankSchedules,
  BankTabs,
  // BankShow,

  /* pl */
  BanksCtx,

  BanksIndexTable,

  BanksProvider,

  BanksSearchModal,

  ContactsList,
  Criterion,
  CriterionModal,
  // Criteria,

  operator,

  ResultsTable,

  Tab, TabList, TabPanel,

}